import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { sessionExpiredAtom } from '@/store/auth.atom'

/**
 * If a request fails with auth error and we mark the session as expired,
 * redirect user back to login.
 *
 * Must live inside React tree so we can use router navigation.
 */
export function SessionExpiredRedirect() {
  const navigate = useNavigate()
  const [expired, setExpired] = useAtom(sessionExpiredAtom)

  useEffect(() => {
    if (!expired) return

    setExpired(false)
    navigate({ to: '/login', replace: true })
  }, [expired, setExpired, navigate])

  return null
}
